// extracted by mini-css-extract-plugin
module.exports = {"root":"Icon_root__hVaEy","fullSize":"Icon_fullSize__3s7VB"};